import { render, staticRenderFns } from "./PointNetridecashFormSet.vue?vue&type=template&id=0f1e4caa"
import script from "./PointNetridecashFormSet.vue?vue&type=script&lang=js"
export * from "./PointNetridecashFormSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports